import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "./useSmoothScroll";

const LINKS = [
  ["how", "How it works"],
  ["categories", "Categories"],
  ["why", "Why urgent"],
  ["faq", "FAQ"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 inset-x-0 z-50 border-b border-white/[0.08] bg-[#0A0B0E]/80 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <button onClick={() => go("top")} data-testid="nav-logo" aria-label="UrgentSellBuy home">
          <Logo />
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`}
              className="text-sm text-zinc-300 hover:text-white transition-colors">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button onClick={() => go("early-access")} data-testid="nav-waitlist-btn"
            className="group hidden sm:inline-flex items-center gap-1.5 rounded-full bg-[#FF3838] px-4 py-2 text-sm font-semibold text-[#0A0B0E] hover:bg-[#ff5656] transition-colors">
            Get early access
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
          </button>
          <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/[0.08] bg-[#0A0B0E] px-5 py-6 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {[...LINKS, ["early-access", "Get early access"]].map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-mobile-link-${id}`}
              className="text-left font-display text-2xl">
              {label}
            </button>
          ))}
        </div>
      )}
    </motion.header>
  );
};
